import { Helmet } from 'react-helmet-async';

import { TripCards } from './_authenticated._main.trips/TripCards';
import { TripTable } from './_authenticated._main.trips/TripTable';
import { t } from '../services/translation/translation';

export const TripsListRoute = () => {
  return (
    <div>
      <Helmet>
        <title>{t('trips-list-route.title')} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white lg:mb-6 ">{t('trips-list-route.title')}</h3>
      <div className="hidden xl:block">
        <TripTable />
      </div>
      <div className="xl:hidden justify-center flex">
        <TripCards />
      </div>
    </div>
  );
};
